import Status from "../../views/modules/Status/Status.vue";
import ResultsByMonth from "../../views/modules/Status/results/ResultsByMonth.vue";
import BalanceGeneral from "../../views/modules/Status/balanceGerenal/BalanceGeneral.vue";
import Budgets from "../../views/modules/Status/budget/Budgets.vue";
//import Budgets2 from "../../views/modules/Status/budget/Budgets2.vue";
import ReasonFinancial from "../../views/modules/Status/reasonFinancial/ReasonFinancial.vue";
//import InConstruction from "../../views/modules/Status/cashFlow/inConstruction.vue";
import CashFlow2 from "@/views/modules/projects/CashFlow2.vue";
import Project from "@/views/modules/projects/Project.vue";
//import budgetExecution from "@/views/modules/Status/budgetExecution/budgetExecution.vue";

import layouts from "../../layout";

export default {
  path: "/status",
  name: "status",
  component: Status,
  meta: {
    auth: true,
    title: "Finanzas",
    tags: ["results-status"]
  },
  redirect: {
    name: "Masterbudget"
  },
  children: [
    {
      path: "Masterbudget",
      name: "Masterbudget",
      component: Budgets,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Presupuesto Maestro",
        tags: ["Masterbudget"],
        index: true
      }
    },
    // {
    //   path: "budget",
    //   name: "budget",
    //   component: {
    //     name: "budget",
    //     render: (h) => h("router-view")
    //   },
    //   meta: {
    //     auth: true,
    //     title: "Budget"
    //   },
    //   children: [
    //     {
    //       path: "Masterbudget",
    //       name: "Masterbudget",
    //       component: Budgets,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Presupuesto Maestro",
    //         tags: ["Masterbudget"],
    //         index: true
    //       }
    //     },
    //     {
    //       path: "budget-execution",
    //       name: "budget-execution",
    //       component: budgetExecution,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Ejecucion de presuspuesto",
    //         tags: ["budget-execution"],
    //         index: true
    //       }
    //     },
    //     {
    //       path: "execution-budget",
    //       name: "execution-budget",
    //       component: Budgets2,
    //       meta: {
    //         auth: true,
    //         searchable: true,
    //         layout: layouts.navLeft,
    //         title: "Execution Budget",
    //         tags: ["execution budget"],
    //         index: true
    //       }
    //     }
    //   ]
    // },
    {
      path: "Statuses",
      name: "Statuses",
      component: {
        name: "Statuses",
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        title: "Statuses"
      },
      children: [
        {
          path: "results-status",
          name: "results-status",
          component: ResultsByMonth,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Estados Financieros",
            tags: ["results-status"],
            index: true
          }
        },
        {
          path: "general-balance",
          name: "general-balance",
          component: BalanceGeneral,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "General Balance",
            tags: ["general-balance"],
            index: true
          }
        },
        {
          path: "reasons-financial",
          name: "reasons-financial",
          component: ReasonFinancial,
          meta: {
            auth: true,
            searchable: true,
            layout: layouts.navLeft,
            title: "Razones Financieras",
            tags: ["reasons-financial"],
            index: true
          }
        }
      ]
    },

    {
      path: "cashflow",
      name: "cashflow",
      component: {
        name: "cashflow",
        render: (h) => h("router-view")
      },
      meta: {
        auth: true,
        title: "CashFlow"
      },
      children: [
        {
          path: "general-cashFlow", // general-cashFlow2
          name: "general-cashFlow", // general-cashFlow2
          component: CashFlow2,
          meta: {
            auth: true,
            title: "General CashFlow", // General CashFlow 2
            index: true
          }
        },
        {
          path: "project-cashFlow",
          name: "project-cashFlow",
          component: Project,
          meta: {
            auth: true,
            title: "Project CashFlow",
            index: true
          }
        }
      ]
    }
    // {
    //   path: "cash-projection",
    //   name: "cash-projection",
    //   component: InConstruction,
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Flujo de Efectivo",
    //     tags: ["cash-projection"],
    //     index: true
    //   }
    // },
    // {
    //   path: "reportsurvey",
    //   name: "employees-reportsurvey",
    //   component: () => import("@/views/modules/SurveyAnswer/ReportSurvey.vue"),
    //   meta: {
    //     auth: true,
    //     searchable: true,
    //     layout: layouts.navLeft,
    //     title: "Respuesta de Empleados",
    //     index: true,
    //     // Pass props to the component
    //     props: {
    //       // Define your props here
    //       prop1: "value1",
    //       prop2: "value2"
    //       // ...,
    //     }
    //   }
    // }
  ]
};
